/* Global SCSS Variables -------------------------------------------------------------------------- */

@import "./tokens.scss";

.mdc-dialog__body.mdc-dialog__body--scrollable {
  overscroll-behavior: contain;
}
